import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiStudioSellerStatsInit } from '@wix/da-papi-types';
import ReportsSection from '../ReportsSection';
import ReasonProgressBar from './_partials/ReasonProgressBar';

import s from './SubsCancellationReasonsSection.scss';

export interface Props {
  className?: string;
  data?: PapiStudioSellerStatsInit['subsCancellationReasons'];
}

const SubsCancellationReasonsSection: FC<Props> = ({
  data,
  className,
}) => {
  const { t } = useTranslation();

  const getReasonLabel = (reason?: number) =>
    t(`studio.subsCancellationReasons.reason.${reason ?? 0}`);

  return (
    <ReportsSection
      reportType="subsCancellationReasons"
      className={className}
      title={t('studio.reports.section.subsCancellationReasons.title')}
      description={t(
        'studio.reports.section.subsCancellationReasons.description',
        {
          postProcess: ['reactPostprocessor'],
          learnMoreLink: (
            <a
              className="text-link-level-2-tertiary"
              href={t(
                'studio.reports.section.subsCancellationReasons.description.learnMoreLink.url'
              )}
            >
              {t(
                'studio.reports.section.subsCancellationReasons.description.learnMoreLink.text'
              )}
            </a>
          ),
        }
      )}
      data={data}
      renderTable={(
        filteredData: Array<{ reason?: number; percentage: number | null }>
      ) => {
        // Sort data from biggest percentage to smallest
        const sortedData = [...filteredData].sort((a, b) => {
          const aPercentage = a.percentage ?? 0;
          const bPercentage = b.percentage ?? 0;
          return bPercentage - aPercentage;
        });

        return (
          <div className={s['reasons-list']}>
            {sortedData.map((item, index) => (
              <div key={index} className={s['reason-item']}>
                <div className={s['reason-label']}>
                  {getReasonLabel(item.reason)}
                </div>
                <ReasonProgressBar percentage={item.percentage} />
              </div>
            ))}
          </div>
        );
      }}
    />
  );
};

SubsCancellationReasonsSection.displayName = 'SubsCancellationReasonsSection';

export default SubsCancellationReasonsSection;
